/**
 * Mapped service codes and their required attributes
 * Also including the additional Home Buddy attributes (that have implementations existing)
 * Also including the slug that maps each specific trade to Modernize.com
 * @type {Array}
 */
export const serviceCodesAndAttributions = [
	{
		serviceCodes: ['ALERTS_MEDICAL'],
		requiredAttributes: ['MedicalAlertProtectionAt', 'WhoseMedicalAlert', 'HasLandlineAtHome'],
		modernizeTradePageSlug: 'medical-alert-systems'
	},
	{
		serviceCodes: ['BASEMENT_WATERPROOFING', 'CRAWLSPACE_ENCAPSULATION'],
		requiredAttributes: ['OwnHome'],
		modernizeTradePageSlug: 'foundations/basement-waterproofing'
	},
	{
		serviceCodes: ['BATH_REMODEL'],
		requiredAttributes: ['BathProjectScope', 'OptIn1', 'OwnHome'],
		homebuddyAttributes: ['ConvertRemodelReasons', 'ExistingProblems', 'SafetyFeatures', 'MainReasonToUpdate', 'ExistingIssues'],
		modernizeTradePageSlug: 'bathroom-remodel'
	},
	{
		serviceCodes: ['BATHROOM_REFACING'],
		requiredAttributes: ['BathProjectScope', 'OwnHome', 'OptIn1'],
		homebuddyAttributes: ['ConvertRemodelReasons', 'ExistingProblems', 'SafetyFeatures', 'MainReasonToUpdate', 'ExistingIssues'],
		modernizeTradePageSlug: 'bathroom-remodel'
	},
	{
		serviceCodes: ['CONCRETE_FOUNDATION'],
		requiredAttributes: ['ConcreteProjectScope', 'OwnHome'],
		modernizeTradePageSlug: 'foundations'
	},
	{
		serviceCodes: ['CABINET_INSTALL', 'CABINET_REFACING'],
		requiredAttributes: ['OwnHome'],
		modernizeTradePageSlug: 'kitchen-remodel/cabinets'
	},
	{
		serviceCodes: ['COUNTERTOP'],
		requiredAttributes: ['CountertopType', 'CountertopProjectScope', 'CommercialLocation', 'BuyTimeframe', 'OwnHome'],
		modernizeTradePageSlug: 'kitchen-remodel'
	},
	{
		serviceCodes: ['DECK'],
		requiredAttributes: ['DeckProjectScope', 'DeckMaterial'],
		modernizeTradePageSlug: 'decks'
	},
	{
		serviceCodes: ['DOOR'],
		requiredAttributes: ['DoorProjectScope', 'DoorsNumber', 'DoorType', 'OwnHome'],
		modernizeTradePageSlug: 'doors'
	},
	{
		serviceCodes: ['DRAINS', 'SEWER'],
		requiredAttributes: ['DrainageIssue', 'OwnHome'],
		modernizeTradePageSlug: 'plumbing'
	},
	{
		serviceCodes: ['FENCING', 'FENCE_WOOD', 'FENCE_VINYL', 'FENCING_CHAINLINK', 'FENCE_METAL'],
		requiredAttributes: ['ProjectScope', 'OwnHome'],
		modernizeTradePageSlug: 'fencing'
	},
	{
		serviceCodes: ['FLOORING_HARDWOOD', 'FLOORING_TILE', 'FLOORING_VINYL_LINOLEUM', 'FLOORING_LAMINATE', 'FLOORING_SUBFLOORS', 'CARPET'],
		requiredAttributes: ['CommercialLocation', 'FlooringProjectScope', 'MaterialPurchase', 'OwnHome'],
		modernizeTradePageSlug: 'flooring'
	},
	{
		serviceCodes: ['GARAGE_DOOR'],
		requiredAttributes: ['GarageDoorSize', 'OwnHome', 'ProjectScope'],
		modernizeTradePageSlug: 'garage-doors'
	},
	{
		serviceCodes: ['GENERATORS'],
		requiredAttributes: ['ProjectScope', 'GeneratorType', 'OwnHome'],
		modernizeTradePageSlug: 'generators'
	},
	{
		serviceCodes: ['GUTTER_COVERS'],
		requiredAttributes: ['CommercialLocation', 'OwnHome'],
		modernizeTradePageSlug: 'gutters'
	},
	{
		serviceCodes: ['HOME_SECURITY'],
		requiredAttributes: ['CommercialLocation', 'HomeSecurityProjectScope', 'Monitoring', 'SecuritySystemInstallationType'],
		modernizeTradePageSlug: 'home-security'
	},
	{
		serviceCodes: ['HOME_WARRANTY'],
		requiredAttributes: ['Interest', 'OwnHome'],
		modernizeTradePageSlug: 'home-warranty'
	},
	{
		serviceCodes: ['HOT_TUBS'],
		requiredAttributes: ['HotTubUse', 'HotTubType', 'OwnHome'],
		modernizeTradePageSlug: 'hot-tub-spas'
	},
	{
		serviceCodes: ['HVAC'],
		requiredAttributes: ['HVACProjectScope', 'HVACInterest', 'OwnHome'],
		modernizeTradePageSlug: 'hvac'
	},
	{
		serviceCodes: ['INSULATION'],
		requiredAttributes: ['OwnHome', 'SubProductService', 'InsulationLocation'],
		modernizeTradePageSlug: 'insulation'
	},
	{
		serviceCodes: ['KITCHEN_REMODEL'],
		requiredAttributes: ['OptIn', 'OwnHome'],
		modernizeTradePageSlug: 'kitchen-remodel'
	},
	{
		serviceCodes: ['PAVERS'],
		requiredAttributes: ['ProjectScope', 'OwnHome'],
		modernizeTradePageSlug: ''
	},
	{
		serviceCodes: ['PLUMBING'],
		requiredAttributes: ['OwnHome', 'PlumbingProjectScope'],
		modernizeTradePageSlug: 'plumbing'
	},
	{
		serviceCodes: ['ROOFING_ASPHALT', 'ROOFING_COMPOSITE', 'ROOFING_CEDAR_SHAKE', 'ROOFING_METAL', 'ROOFING_NATURAL_SLATE', 'ROOFING_TILE'],
		requiredAttributes: ['OwnHome', 'RoofingPlan'],
		homebuddyAttributes: ['RoofCondition', 'RoofMountedEquipment', 'RoofFeatures', 'HouseAttic', 'RoofDrainageSystem', 'HomeStories', 'RoofSize', 'RoofAge'],
		modernizeTradePageSlug: 'roof'
	},
	{
		serviceCodes: ['SIDING_VINYL', 'SIDING_ALUMINIUM', 'SIDING_BRICKFACE', 'SIDING_COMPOSITE_WOOD', 'SIDING_STONEFACE', 'STUCCO_EXTERIOR'],
		requiredAttributes: ['OwnHome', 'ProjectPlan'],
		modernizeTradePageSlug: 'siding'
	},
	{
		serviceCodes: ['SOLAR'],
		requiredAttributes: ['ElectricBill', 'OwnHome', 'UtilityProvider'],
		modernizeTradePageSlug: 'solar'
	},
	{
		serviceCodes: ['STAIR_LIFTS'],
		requiredAttributes: ['OwnHome', 'ReasonForStairLift'],
		modernizeTradePageSlug: 'stair-lifts'
	},
	{
		serviceCodes: ['TREE_SERVICES'],
		requiredAttributes: ['CommercialLocation', 'JobType', 'NumberOfTrees', 'OwnHome', 'TreeSize'],
		modernizeTradePageSlug: 'tree-services'
	},
	{
		serviceCodes: ['WALK_IN_TUBS', 'WALK_IN_SHOWERS'],
		requiredAttributes: ['Interest', 'OwnHome'],
		modernizeTradePageSlug: 'walk-in-tubs'
	},
	{
		serviceCodes: ['WATER_HEATERS'],
		requiredAttributes: ['ProjectScope', 'OwnHome'],
		modernizeTradePageSlug: 'plumbing'
	},
	{
		serviceCodes: ['WATER_MAIN'],
		requiredAttributes: ['OwnHome'],
		modernizeTradePageSlug: 'plumbing'
	},
	{
		serviceCodes: ['WATER_TREATMENT'],
		requiredAttributes: ['BuyTimeframe', 'OwnHome', 'ServiceType'],
		modernizeTradePageSlug: 'plumbing/water-treatment'
	},
	{
		serviceCodes: ['WINDOWS'],
		requiredAttributes: ['NumberOfWindows', 'OwnHome', 'WindowsProjectScope'],
		homebuddyAttributes: ['HomeStories', 'WindowShape', 'WindowMaterial', 'WindowCondition', 'WindowReplaceReason'],
		modernizeTradePageSlug: 'windows'
	}
];
